// import React, { useState, useEffect } from 'react';
// import API from '../../api'; // make sure API is your Axios instance

// export default function AdminProfile() {
//   const [profile, setProfile] = useState({
//     name: '',
//     email: '',
//     pharmacyName: '',
//     phone: '',
//     pan: '',
//     address: '',
//   });

//   const [loading, setLoading] = useState(false);
//   const [fetching, setFetching] = useState(true);
//   const [successMsg, setSuccessMsg] = useState('');
//   const [errorMsg, setErrorMsg] = useState('');

//   // Fetch profile from backend on mount
//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         const { data } = await API.get('/users/profile', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
        
//         // More defensive handling of data
//         setProfile({
//           name: data.name || data.userName || '',
//           email: data.email || data.userEmail || '',
//           pharmacyName: data.pharmacyName || data.pharmacy_name || '',
//           phone: data.phone || data.phoneNumber || data.phone_number || '',
//           pan: data.pan || data.panNumber || data.pan_number || '',
//           address: data.address || '',
//         });
//       } catch (err) {
//         console.error(err);
//         setErrorMsg('Failed to load profile');
//       } finally {
//         setFetching(false);
//       }
//     };

//     fetchProfile();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setSuccessMsg('');
//     setErrorMsg('');

//     try {
//       const token = localStorage.getItem('token');
//       const { data } = await API.put('/users/profile', profile, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       // Update localStorage
//       localStorage.setItem('userName', data.name || profile.name);
//       localStorage.setItem('userEmail', data.email || profile.email);
//       localStorage.setItem('pharmacyName', data.pharmacyName || profile.pharmacyName);
//       localStorage.setItem('phone', data.phone || profile.phone);
//       localStorage.setItem('pan', data.pan || profile.pan);
//       localStorage.setItem('address', data.address || profile.address);

//       setSuccessMsg('Profile updated successfully!');
//       setTimeout(() => setSuccessMsg(''), 3000);
//     } catch (err) {
//       console.error(err);
//       setErrorMsg(err.response?.data?.message || 'Update failed');
//     }

//     setLoading(false);
//   };

//   if (fetching) {
//     return (
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         minHeight: '100vh',
//         fontFamily: "'Inter', 'Segoe UI', sans-serif",
//       }}>
//         <div style={{ textAlign: 'center' }}>
//           <div style={{
//             width: '48px',
//             height: '48px',
//             border: '4px solid #e2e8f0',
//             borderTop: '4px solid #3b82f6',
//             borderRadius: '50%',
//             animation: 'spin 1s linear infinite',
//             margin: '0 auto 16px'
//           }}></div>
//           <p style={{ color: '#64748b', fontSize: '14px' }}>Loading profile...</p>
//         </div>
//         <style>
//           {`@keyframes spin { to { transform: rotate(360deg); } }`}
//         </style>
//       </div>
//     );
//   }

//   return (
//     <div style={{ 
//       padding: '24px', 
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//       backgroundColor: '#f1f5f9',
//       minHeight: '100vh'
//     }}>
//       <div style={{ maxWidth: '900px', margin: '0 auto' }}>
//         {/* Header Section */}
//         <div style={{ 
//           marginBottom: '32px',
//           background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//           padding: '40px',
//           borderRadius: '20px',
//           color: 'white',
//           boxShadow: '0 10px 40px rgba(102, 126, 234, 0.3)'
//         }}>
//           <h1 style={{ 
//             fontSize: '36px', 
//             fontWeight: '700',
//             marginBottom: '8px', 
//             margin: 0,
//             letterSpacing: '-0.02em'
//           }}>
//             Admin Profile
//           </h1>
//           <p style={{ 
//             fontSize: '16px', 
//             opacity: 0.95,
//             margin: '8px 0 0 0',
//             fontWeight: 400
//           }}>
//             Manage your account information and pharmacy details
//           </p>
//         </div>

//         {/* Success Message */}
//         {successMsg && (
//           <div style={{
//             padding: '16px 24px',
//             backgroundColor: '#f0fdf4',
//             color: '#166534',
//             borderRadius: '16px',
//             marginBottom: '24px',
//             fontWeight: 500,
//             fontSize: '14px',
//             border: '2px solid #bbf7d0',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '12px',
//             boxShadow: '0 4px 6px rgba(22, 101, 52, 0.1)'
//           }}>
//             <div style={{
//               width: '24px',
//               height: '24px',
//               borderRadius: '50%',
//               backgroundColor: '#22c55e',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: 'white',
//               fontSize: '14px',
//               fontWeight: 'bold'
//             }}>✓</div>
//             {successMsg}
//           </div>
//         )}

//         {/* Error Message */}
//         {errorMsg && (
//           <div style={{
//             padding: '16px 24px',
//             backgroundColor: '#fef2f2',
//             color: '#991b1b',
//             borderRadius: '16px',
//             marginBottom: '24px',
//             fontWeight: 500,
//             fontSize: '14px',
//             border: '2px solid #fecaca',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '12px',
//             boxShadow: '0 4px 6px rgba(153, 27, 27, 0.1)'
//           }}>
//             <div style={{
//               width: '24px',
//               height: '24px',
//               borderRadius: '50%',
//               backgroundColor: '#ef4444',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: 'white',
//               fontSize: '16px',
//               fontWeight: 'bold'
//             }}>!</div>
//             {errorMsg}
//           </div>
//         )}

//         {/* Form Card */}
//         <form
//           onSubmit={handleSubmit}
//           style={{
//             backgroundColor: '#ffffff',
//             padding: '0',
//             borderRadius: '20px',
//             boxShadow: '0 4px 6px rgba(0,0,0,0.05), 0 10px 25px rgba(0,0,0,0.05)',
//             overflow: 'hidden'
//           }}
//         >
//           {/* Personal Information Section */}
//           <div style={{ 
//             padding: '32px 40px',
//             borderBottom: '2px solid #f1f5f9'
//           }}>
//             <h2 style={{
//               fontSize: '20px',
//               fontWeight: '700',
//               color: '#1e293b',
//               marginBottom: '8px',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '10px'
//             }}>
//               <span style={{ fontSize: '24px' }}>👤</span>
//               Personal Information
//             </h2>
//             <p style={{ fontSize: '14px', color: '#64748b', margin: '0 0 24px 0' }}>
//               Update your personal details and contact information
//             </p>
            
//             <div style={{ 
//               display: 'grid', 
//               gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//               gap: '24px'
//             }}>
//               <InputField 
//                 label="Full Name" 
//                 name="name" 
//                 value={profile.name} 
//                 onChange={handleChange}
//                 required
//                 icon="👤"
//               />
//               <InputField 
//                 label="Email Address" 
//                 name="email" 
//                 value={profile.email} 
//                 onChange={handleChange} 
//                 type="email"
//                 required
//                 icon="📧"
//               />
//             </div>
//           </div>

//           {/* Pharmacy Information Section */}
//           <div style={{ 
//             padding: '32px 40px',
//             borderBottom: '2px solid #f1f5f9',
//             backgroundColor: '#fafbfc'
//           }}>
//             <h2 style={{
//               fontSize: '20px',
//               fontWeight: '700',
//               color: '#1e293b',
//               marginBottom: '8px',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '10px'
//             }}>
//               <span style={{ fontSize: '24px' }}>🏥</span>
//               Pharmacy Details
//             </h2>
//             <p style={{ fontSize: '14px', color: '#64748b', margin: '0 0 24px 0' }}>
//               Manage your pharmacy and business information
//             </p>
            
//             <div style={{ 
//               display: 'grid', 
//               gap: '24px'
//             }}>
//               <InputField 
//                 label="Pharmacy Name" 
//                 name="pharmacyName" 
//                 value={profile.pharmacyName} 
//                 onChange={handleChange}
//                 icon="🏥"
//               />
//               <div style={{ 
//                 display: 'grid', 
//                 gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//                 gap: '24px'
//               }}>
//                 <InputField 
//                   label="Phone Number" 
//                   name="phone" 
//                   value={profile.phone} 
//                   onChange={handleChange} 
//                   type="tel"
//                   placeholder="e.g., +977 98XXXXXXXX"
//                   icon="📱"
//                 />
//                 <InputField 
//                   label="PAN Number" 
//                   name="pan" 
//                   value={profile.pan} 
//                   onChange={handleChange}
//                   placeholder="e.g., 123456789"
//                   icon="🔢"
//                 />
//               </div>
//               <TextAreaField
//                 label="Complete Address"
//                 name="address"
//                 value={profile.address}
//                 onChange={handleChange}
//                 placeholder="Enter your pharmacy's complete address including street, city, and postal code"
//                 icon="📍"
//               />
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div style={{ 
//             padding: '32px 40px',
//             backgroundColor: '#ffffff',
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center'
//           }}>
//             <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>
//               * Required fields must be filled
//             </p>
//             <button
//               type="submit"
//               disabled={loading}
//               style={{
//                 padding: '14px 40px',
//                 borderRadius: '12px',
//                 border: 'none',
//                 background: loading 
//                   ? 'linear-gradient(135deg, #94a3b8 0%, #64748b 100%)' 
//                   : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                 color: '#ffffff',
//                 fontWeight: 600,
//                 fontSize: '15px',
//                 cursor: loading ? 'not-allowed' : 'pointer',
//                 transition: 'all 0.3s ease',
//                 boxShadow: loading ? 'none' : '0 4px 15px rgba(102, 126, 234, 0.4)',
//                 transform: loading ? 'none' : 'translateY(0)',
//               }}
//               onMouseEnter={(e) => {
//                 if (!loading) {
//                   e.target.style.transform = 'translateY(-2px)';
//                   e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.5)';
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (!loading) {
//                   e.target.style.transform = 'translateY(0)';
//                   e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
//                 }
//               }}
//             >
//               {loading ? (
//                 <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <span style={{
//                     width: '16px',
//                     height: '16px',
//                     border: '2px solid rgba(255,255,255,0.3)',
//                     borderTop: '2px solid white',
//                     borderRadius: '50%',
//                     animation: 'spin 0.8s linear infinite'
//                   }}></span>
//                   Updating...
//                 </span>
//               ) : (
//                 '💾 Save Changes'
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//       <style>
//         {`@keyframes spin { to { transform: rotate(360deg); } }`}
//       </style>
//     </div>
//   );
// }

// // Reusable input component
// function InputField({ label, name, value, onChange, type = 'text', placeholder = '', required = false, icon }) {
//   return (
//     <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//       <label style={{ 
//         fontWeight: 600, 
//         color: '#334155',
//         fontSize: '14px',
//         letterSpacing: '-0.01em',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px'
//       }}>
//         {icon && <span style={{ fontSize: '16px' }}>{icon}</span>}
//         {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
//       </label>
//       <input
//         type={type}
//         name={name}
//         value={value || ''} // Ensure empty string if undefined
//         onChange={onChange}
//         placeholder={placeholder}
//         required={required}
//         style={{
//           padding: '14px 16px',
//           borderRadius: '12px',
//           border: '2px solid #e2e8f0',
//           outline: 'none',
//           fontSize: '15px',
//           color: '#1e293b',
//           backgroundColor: '#ffffff',
//           transition: 'all 0.2s ease',
//           fontFamily: "'Inter', 'Segoe UI', sans-serif",
//         }}
//         onFocus={(e) => {
//           e.target.style.borderColor = '#667eea';
//           e.target.style.boxShadow = '0 0 0 4px rgba(102, 126, 234, 0.1)';
//         }}
//         onBlur={(e) => {
//           e.target.style.borderColor = '#e2e8f0';
//           e.target.style.boxShadow = 'none';
//         }}
//       />
//     </div>
//   );
// }

// // Reusable textarea component for address
// function TextAreaField({ label, name, value, onChange, placeholder = '', required = false, icon }) {
//   return (
//     <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//       <label style={{ 
//         fontWeight: 600, 
//         color: '#334155',
//         fontSize: '14px',
//         letterSpacing: '-0.01em',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px'
//       }}>
//         {icon && <span style={{ fontSize: '16px' }}>{icon}</span>}
//         {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
//       </label>
//       <textarea
//         name={name}
//         value={value || ''} // Ensure empty string if undefined
//         onChange={onChange}
//         placeholder={placeholder}
//         required={required}
//         rows={4}
//         style={{
//           padding: '14px 16px',
//           borderRadius: '12px',
//           border: '2px solid #e2e8f0',
//           outline: 'none',
//           fontSize: '15px',
//           color: '#1e293b',
//           backgroundColor: '#ffffff',
//           transition: 'all 0.2s ease',
//           fontFamily: "'Inter', 'Segoe UI', sans-serif",
//           resize: 'vertical',
//           minHeight: '100px'
//         }}
//         onFocus={(e) => {
//           e.target.style.borderColor = '#667eea';
//           e.target.style.boxShadow = '0 0 0 4px rgba(102, 126, 234, 0.1)';
//         }}
//         onBlur={(e) => {
//           e.target.style.borderColor = '#e2e8f0';
//           e.target.style.boxShadow = 'none';
//         }}
//       />
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import { 
  User, Mail, Phone, Building2, Hash, MapPin, Shield, Crown, 
  Camera, Key, Lock, Eye, EyeOff, Calendar, Clock, Activity,
  Users, CheckCircle, AlertTriangle, Settings, Bell, LogOut,
  Save, RefreshCw, Trash2, Edit2
} from 'lucide-react';
import API from '../../api';

export default function AdminProfile() {
  // Profile State
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    pharmacyName: '',
    phone: '',
    pan: '',
    address: '',
    role: '',
    status: '',
    createdAt: '',
    updatedAt: '',
    lastLogin: '',
    profilePicture: ''
  });

  // Stats State
  const [stats, setStats] = useState({
    totalAdmins: 0,
    totalStaff: 0,
    totalUsers: 0,
    activeUsers: 0
  });

  // Password State
  const [showPasswordSection, setShowPasswordSection] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // UI State
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [activeTab, setActiveTab] = useState('profile');

  // Fetch Profile
  useEffect(() => {
    fetchProfile();
    fetchStats();
  }, []);

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem('token');
      const { data } = await API.get('/users/profile', {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      setProfile({
        name: data.name || '',
        email: data.email || '',
        pharmacyName: data.pharmacyName || '',
        phone: data.phone || '',
        pan: data.pan || '',
        address: data.address || '',
        role: data.role || 'admin',
        status: data.status || 'active',
        createdAt: data.createdAt || '',
        updatedAt: data.updatedAt || '',
        lastLogin: data.lastLogin || '',
        profilePicture: data.profilePicture || ''
      });
    } catch (err) {
      console.error(err);
      setErrorMsg('Failed to load profile');
    } finally {
      setFetching(false);
    }
  };

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const { data } = await API.get('/users/admin/users-hierarchy', {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      if (data.stats) {
        setStats({
          totalAdmins: (data.stats.totalSuperAdmins || 0) + (data.stats.totalAdmins || 0),
          totalStaff: data.stats.totalStaff || 0,
          totalUsers: (data.stats.totalSuperAdmins || 0) + (data.stats.totalAdmins || 0) + (data.stats.totalStaff || 0),
          activeUsers: data.stats.activeAdmins || 0
        });
      }
    } catch (err) {
      console.error('Stats fetch error:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg('');
    setErrorMsg('');

    try {
      const token = localStorage.getItem('token');
      const { data } = await API.put('/users/profile', {
        name: profile.name,
        email: profile.email,
        pharmacyName: profile.pharmacyName,
        phone: profile.phone,
        pan: profile.pan,
        address: profile.address
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Update localStorage
      localStorage.setItem('userName', data.user?.name || profile.name);
      localStorage.setItem('userEmail', data.user?.email || profile.email);
      localStorage.setItem('pharmacyName', data.user?.pharmacyName || profile.pharmacyName);

      setSuccessMsg('Profile updated successfully!');
      setTimeout(() => setSuccessMsg(''), 4000);
    } catch (err) {
      console.error(err);
      setErrorMsg(err.response?.data?.message || 'Update failed');
      setTimeout(() => setErrorMsg(''), 4000);
    }
    setLoading(false);
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setErrorMsg('New passwords do not match');
      setTimeout(() => setErrorMsg(''), 4000);
      return;
    }

    if (passwordData.newPassword.length < 6) {
      setErrorMsg('Password must be at least 6 characters');
      setTimeout(() => setErrorMsg(''), 4000);
      return;
    }

    setPasswordLoading(true);
    setSuccessMsg('');
    setErrorMsg('');

    try {
      const token = localStorage.getItem('token');
      await API.put('/users/profile', {
        password: passwordData.newPassword
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSuccessMsg('Password changed successfully!');
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setShowPasswordSection(false);
      setTimeout(() => setSuccessMsg(''), 4000);
    } catch (err) {
      console.error(err);
      setErrorMsg(err.response?.data?.message || 'Password change failed');
      setTimeout(() => setErrorMsg(''), 4000);
    }
    setPasswordLoading(false);
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatDateTime = (date) => {
    if (!date) return 'Never';
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getRoleBadge = (role) => {
    if (role === 'superadmin') {
      return { bg: '#fef3c7', color: '#b45309', icon: <Crown size={14} />, text: 'SUPER ADMIN' };
    }
    return { bg: '#f3e8ff', color: '#7e22ce', icon: <Shield size={14} />, text: 'ADMIN' };
  };

  const getStatusBadge = (status) => {
    const map = {
      active: { bg: '#d1fae5', color: '#065f46', icon: <CheckCircle size={14} /> },
      trial: { bg: '#dbeafe', color: '#1e40af', icon: <Clock size={14} /> },
      expired: { bg: '#fee2e2', color: '#991b1b', icon: <AlertTriangle size={14} /> },
      inactive: { bg: '#fef3c7', color: '#92400e', icon: <AlertTriangle size={14} /> }
    };
    return map[status] || map.active;
  };

  if (fetching) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.spinner}></div>
        <p style={{ color: '#64748b', fontSize: 14, marginTop: 16 }}>Loading profile...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  const roleBadge = getRoleBadge(profile.role);
  const statusBadge = getStatusBadge(profile.status);

  return (
    <div style={styles.container}>
      <div style={styles.maxWidth}>
        
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerContent}>
            <div style={styles.avatarSection}>
              <div style={styles.avatarWrapper}>
                {profile.profilePicture ? (
                  <img src={profile.profilePicture} alt="Profile" style={styles.avatarImage} />
                ) : (
                  <div style={styles.avatarPlaceholder}>
                    {profile.role === 'superadmin' ? <Crown size={32} /> : profile.name?.charAt(0).toUpperCase() || 'A'}
                  </div>
                )}
                <button style={styles.avatarEditBtn}>
                  <Camera size={14} />
                </button>
              </div>
              
              <div style={styles.headerInfo}>
                <h1 style={styles.headerName}>{profile.name || 'Admin User'}</h1>
                <p style={styles.headerEmail}>{profile.email}</p>
                <div style={styles.badgeContainer}>
                  <span style={{ ...styles.badge, background: roleBadge.bg, color: roleBadge.color }}>
                    {roleBadge.icon} {roleBadge.text}
                  </span>
                  <span style={{ ...styles.badge, background: statusBadge.bg, color: statusBadge.color }}>
                    {statusBadge.icon} {profile.status?.toUpperCase()}
                  </span>
                </div>
              </div>
            </div>
            
            <div style={styles.headerStats}>
              <StatMini icon={<Users size={18} />} value={stats.totalUsers} label="Total Users" color="#6366f1" />
              <StatMini icon={<Shield size={18} />} value={stats.totalAdmins} label="Admins" color="#8b5cf6" />
              <StatMini icon={<Activity size={18} />} value={stats.activeUsers} label="Active" color="#10b981" />
            </div>
          </div>
        </div>

        {/* Messages */}
        {successMsg && (
          <div style={styles.successMsg}>
            <CheckCircle size={20} />
            {successMsg}
          </div>
        )}
        {errorMsg && (
          <div style={styles.errorMsg}>
            <AlertTriangle size={20} />
            {errorMsg}
          </div>
        )}

        {/* Tabs */}
        <div style={styles.tabContainer}>
          <button 
            onClick={() => setActiveTab('profile')} 
            style={{ ...styles.tab, ...(activeTab === 'profile' ? styles.tabActive : {}) }}
          >
            <User size={18} /> Profile
          </button>
          <button 
            onClick={() => setActiveTab('security')} 
            style={{ ...styles.tab, ...(activeTab === 'security' ? styles.tabActive : {}) }}
          >
            <Lock size={18} /> Security
          </button>
          <button 
            onClick={() => setActiveTab('account')} 
            style={{ ...styles.tab, ...(activeTab === 'account' ? styles.tabActive : {}) }}
          >
            <Settings size={18} /> Account
          </button>
        </div>

        {/* Profile Tab */}
        {activeTab === 'profile' && (
          <form onSubmit={handleSubmit} style={styles.card}>
            <div style={styles.cardHeader}>
              <div>
                <h2 style={styles.cardTitle}><User size={20} /> Personal Information</h2>
                <p style={styles.cardSubtitle}>Update your personal and pharmacy details</p>
              </div>
            </div>
            
            <div style={styles.cardBody}>
              <div style={styles.formGrid}>
                <InputField 
                  icon={<User size={18} />}
                  label="Full Name" 
                  name="name" 
                  value={profile.name} 
                  onChange={handleChange}
                  required
                />
                <InputField 
                  icon={<Mail size={18} />}
                  label="Email Address" 
                  name="email" 
                  value={profile.email} 
                  onChange={handleChange} 
                  type="email"
                  required
                />
                <InputField 
                  icon={<Phone size={18} />}
                  label="Phone Number" 
                  name="phone" 
                  value={profile.phone} 
                  onChange={handleChange}
                  placeholder="+977 98XXXXXXXX"
                />
                <InputField 
                  icon={<Building2 size={18} />}
                  label="Pharmacy Name" 
                  name="pharmacyName" 
                  value={profile.pharmacyName} 
                  onChange={handleChange}
                />
                <InputField 
                  icon={<Hash size={18} />}
                  label="PAN Number" 
                  name="pan" 
                  value={profile.pan} 
                  onChange={handleChange}
                />
                <div style={{ gridColumn: '1 / -1' }}>
                  <TextAreaField
                    icon={<MapPin size={18} />}
                    label="Address"
                    name="address"
                    value={profile.address}
                    onChange={handleChange}
                    placeholder="Enter your complete address"
                  />
                </div>
              </div>
            </div>
            
            <div style={styles.cardFooter}>
              <button type="button" onClick={fetchProfile} style={styles.secondaryBtn}>
                <RefreshCw size={16} /> Reset
              </button>
              <button type="submit" disabled={loading} style={{ ...styles.primaryBtn, opacity: loading ? 0.7 : 1 }}>
                {loading ? (
                  <><span style={styles.btnSpinner}></span> Saving...</>
                ) : (
                  <><Save size={16} /> Save Changes</>
                )}
              </button>
            </div>
          </form>
        )}

        {/* Security Tab */}
        {activeTab === 'security' && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <div>
                <h2 style={styles.cardTitle}><Lock size={20} /> Security Settings</h2>
                <p style={styles.cardSubtitle}>Manage your password and security preferences</p>
              </div>
            </div>
            
            <div style={styles.cardBody}>
              {/* Change Password Section */}
              <div style={styles.securitySection}>
                <div style={styles.securityHeader}>
                  <div style={styles.securityIcon}><Key size={20} /></div>
                  <div>
                    <h3 style={styles.securityTitle}>Change Password</h3>
                    <p style={styles.securityDesc}>Update your password regularly for better security</p>
                  </div>
                  <button 
                    onClick={() => setShowPasswordSection(!showPasswordSection)}
                    style={styles.expandBtn}
                  >
                    {showPasswordSection ? 'Cancel' : 'Change'}
                  </button>
                </div>
                
                {showPasswordSection && (
                  <form onSubmit={handlePasswordSubmit} style={styles.passwordForm}>
                    <div style={styles.passwordField}>
                      <label style={styles.label}>Current Password</label>
                      <div style={styles.passwordInputWrapper}>
                        <input
                          type={showCurrentPassword ? 'text' : 'password'}
                          name="currentPassword"
                          value={passwordData.currentPassword}
                          onChange={handlePasswordChange}
                          style={styles.input}
                          placeholder="Enter current password"
                          required
                        />
                        <button 
                          type="button" 
                          onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                          style={styles.eyeBtn}
                        >
                          {showCurrentPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                      </div>
                    </div>
                    
                    <div style={styles.passwordField}>
                      <label style={styles.label}>New Password</label>
                      <div style={styles.passwordInputWrapper}>
                        <input
                          type={showNewPassword ? 'text' : 'password'}
                          name="newPassword"
                          value={passwordData.newPassword}
                          onChange={handlePasswordChange}
                          style={styles.input}
                          placeholder="Enter new password (min 6 characters)"
                          required
                        />
                        <button 
                          type="button" 
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          style={styles.eyeBtn}
                        >
                          {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                      </div>
                    </div>
                    
                    <div style={styles.passwordField}>
                      <label style={styles.label}>Confirm New Password</label>
                      <div style={styles.passwordInputWrapper}>
                        <input
                          type={showConfirmPassword ? 'text' : 'password'}
                          name="confirmPassword"
                          value={passwordData.confirmPassword}
                          onChange={handlePasswordChange}
                          style={styles.input}
                          placeholder="Confirm new password"
                          required
                        />
                        <button 
                          type="button" 
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          style={styles.eyeBtn}
                        >
                          {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                      </div>
                    </div>
                    
                    <button type="submit" disabled={passwordLoading} style={{ ...styles.primaryBtn, width: '100%' }}>
                      {passwordLoading ? (
                        <><span style={styles.btnSpinner}></span> Updating...</>
                      ) : (
                        <><Lock size={16} /> Update Password</>
                      )}
                    </button>
                  </form>
                )}
              </div>

              {/* Two Factor Auth */}
              <div style={styles.securitySection}>
                <div style={styles.securityHeader}>
                  <div style={{ ...styles.securityIcon, background: '#dbeafe', color: '#2563eb' }}><Shield size={20} /></div>
                  <div>
                    <h3 style={styles.securityTitle}>Two-Factor Authentication</h3>
                    <p style={styles.securityDesc}>Add an extra layer of security to your account</p>
                  </div>
                  <span style={{ ...styles.badge, background: '#fee2e2', color: '#991b1b' }}>Coming Soon</span>
                </div>
              </div>

              {/* Login Notifications */}
              <div style={styles.securitySection}>
                <div style={styles.securityHeader}>
                  <div style={{ ...styles.securityIcon, background: '#fef3c7', color: '#b45309' }}><Bell size={20} /></div>
                  <div>
                    <h3 style={styles.securityTitle}>Login Notifications</h3>
                    <p style={styles.securityDesc}>Get notified when someone logs into your account</p>
                  </div>
                  <span style={{ ...styles.badge, background: '#d1fae5', color: '#065f46' }}><CheckCircle size={12} /> Enabled</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Account Tab */}
        {activeTab === 'account' && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <div>
                <h2 style={styles.cardTitle}><Settings size={20} /> Account Information</h2>
                <p style={styles.cardSubtitle}>View your account details and activity</p>
              </div>
            </div>
            
            <div style={styles.cardBody}>
              {/* Account Details */}
              <div style={styles.infoGrid}>
                <InfoItem icon={<Shield size={18} />} label="Account Role" value={
                  <span style={{ ...styles.badge, background: roleBadge.bg, color: roleBadge.color }}>
                    {roleBadge.icon} {roleBadge.text}
                  </span>
                } />
                <InfoItem icon={<Activity size={18} />} label="Account Status" value={
                  <span style={{ ...styles.badge, background: statusBadge.bg, color: statusBadge.color }}>
                    {statusBadge.icon} {profile.status?.toUpperCase()}
                  </span>
                } />
                <InfoItem icon={<Calendar size={18} />} label="Member Since" value={formatDate(profile.createdAt)} />
                <InfoItem icon={<Clock size={18} />} label="Last Updated" value={formatDateTime(profile.updatedAt)} />
                <InfoItem icon={<LogOut size={18} />} label="Last Login" value={formatDateTime(profile.lastLogin)} />
                <InfoItem icon={<Hash size={18} />} label="Account ID" value={
                  <code style={styles.codeText}>{localStorage.getItem('userId')?.slice(-8) || 'N/A'}</code>
                } />
              </div>

              {/* Management Stats */}
              <div style={styles.statsSection}>
                <h3 style={styles.statsSectionTitle}>Management Overview</h3>
                <div style={styles.statsGrid}>
                  <StatCard icon={<Users size={24} />} value={stats.totalUsers} label="Total Users" color="#6366f1" />
                  <StatCard icon={<Shield size={24} />} value={stats.totalAdmins} label="Admins" color="#8b5cf6" />
                  <StatCard icon={<User size={24} />} value={stats.totalStaff} label="Staff" color="#10b981" />
                  <StatCard icon={<CheckCircle size={24} />} value={stats.activeUsers} label="Active" color="#22c55e" />
                </div>
              </div>

              {/* Danger Zone */}
              <div style={styles.dangerZone}>
                <h3 style={styles.dangerTitle}><AlertTriangle size={18} /> Danger Zone</h3>
                <div style={styles.dangerContent}>
                  <div>
                    <p style={styles.dangerText}>Delete your account and all associated data. This action cannot be undone.</p>
                  </div>
                  <button style={styles.dangerBtn} disabled>
                    <Trash2 size={16} /> Delete Account
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
      
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}

// Sub Components
const InputField = ({ icon, label, name, value, onChange, type = 'text', placeholder = '', required = false }) => (
  <div style={styles.formGroup}>
    <label style={styles.label}>{icon} {label} {required && <span style={{ color: '#ef4444' }}>*</span>}</label>
    <input
      type={type}
      name={name}
      value={value || ''}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      style={styles.input}
    />
  </div>
);

const TextAreaField = ({ icon, label, name, value, onChange, placeholder = '' }) => (
  <div style={styles.formGroup}>
    <label style={styles.label}>{icon} {label}</label>
    <textarea
      name={name}
      value={value || ''}
      onChange={onChange}
      placeholder={placeholder}
      rows={3}
      style={{ ...styles.input, resize: 'vertical', minHeight: 80 }}
    />
  </div>
);

const StatMini = ({ icon, value, label, color }) => (
  <div style={styles.statMini}>
    <div style={{ ...styles.statMiniIcon, background: `${color}20`, color }}>{icon}</div>
    <div style={styles.statMiniValue}>{value}</div>
    <div style={styles.statMiniLabel}>{label}</div>
  </div>
);

const StatCard = ({ icon, value, label, color }) => (
  <div style={{ ...styles.statCard, borderLeft: `4px solid ${color}` }}>
    <div style={{ ...styles.statCardIcon, color }}>{icon}</div>
    <div style={styles.statCardValue}>{value}</div>
    <div style={styles.statCardLabel}>{label}</div>
  </div>
);

const InfoItem = ({ icon, label, value }) => (
  <div style={styles.infoItem}>
    <div style={styles.infoLabel}>{icon} {label}</div>
    <div style={styles.infoValue}>{value}</div>
  </div>
);

// Styles
const styles = {
  container: {
    padding: 24,
    fontFamily: "'Inter', -apple-system, sans-serif",
    backgroundColor: '#f1f5f9',
    minHeight: '100vh'
  },
  maxWidth: {
    maxWidth: 1000,
    margin: '0 auto'
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    fontFamily: "'Inter', sans-serif"
  },
  spinner: {
    width: 48,
    height: 48,
    border: '4px solid #e2e8f0',
    borderTop: '4px solid #6366f1',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  
  // Header
  header: {
    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    borderRadius: 20,
    padding: 32,
    marginBottom: 24,
    color: 'white',
    boxShadow: '0 10px 40px rgba(99, 102, 241, 0.3)'
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 24
  },
  avatarSection: {
    display: 'flex',
    alignItems: 'center',
    gap: 20
  },
  avatarWrapper: {
    position: 'relative'
  },
  avatarPlaceholder: {
    width: 80,
    height: 80,
    borderRadius: 16,
    background: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 32,
    fontWeight: 700,
    color: 'white',
    border: '3px solid rgba(255,255,255,0.3)'
  },
  avatarImage: {
    width: 80,
    height: 80,
    borderRadius: 16,
    objectFit: 'cover',
    border: '3px solid rgba(255,255,255,0.3)'
  },
  avatarEditBtn: {
    position: 'absolute',
    bottom: -4,
    right: -4,
    width: 28,
    height: 28,
    borderRadius: 8,
    background: 'white',
    border: 'none',
    color: '#6366f1',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
  },
  headerInfo: {},
  headerName: {
    margin: 0,
    fontSize: 28,
    fontWeight: 700,
    letterSpacing: '-0.02em'
  },
  headerEmail: {
    margin: '4px 0 12px',
    opacity: 0.9,
    fontSize: 14
  },
  badgeContainer: {
    display: 'flex',
    gap: 8
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 11,
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: 6
  },
  headerStats: {
    display: 'flex',
    gap: 16
  },
  statMini: {
    textAlign: 'center',
    padding: '12px 16px',
    background: 'rgba(255,255,255,0.15)',
    borderRadius: 12,
    minWidth: 80
  },
  statMiniIcon: {
    width: 36,
    height: 36,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 8px'
  },
  statMiniValue: {
    fontSize: 20,
    fontWeight: 700
  },
  statMiniLabel: {
    fontSize: 11,
    opacity: 0.8
  },

  // Messages
  successMsg: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '16px 20px',
    background: '#d1fae5',
    color: '#065f46',
    borderRadius: 12,
    marginBottom: 20,
    fontWeight: 500,
    fontSize: 14
  },
  errorMsg: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '16px 20px',
    background: '#fee2e2',
    color: '#991b1b',
    borderRadius: 12,
    marginBottom: 20,
    fontWeight: 500,
    fontSize: 14
  },

  // Tabs
  tabContainer: {
    display: 'flex',
    gap: 8,
    marginBottom: 24,
    background: 'white',
    padding: 6,
    borderRadius: 12,
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
  },
  tab: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '12px 20px',
    border: 'none',
    background: 'transparent',
    color: '#64748b',
    fontSize: 14,
    fontWeight: 600,
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  tabActive: {
    background: '#6366f1',
    color: 'white'
  },

  // Card
  card: {
    background: 'white',
    borderRadius: 16,
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    overflow: 'hidden'
  },
  cardHeader: {
    padding: '24px 28px',
    borderBottom: '1px solid #f1f5f9'
  },
  cardTitle: {
    margin: 0,
    fontSize: 18,
    fontWeight: 700,
    color: '#1e293b',
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  cardSubtitle: {
    margin: '6px 0 0',
    fontSize: 14,
    color: '#64748b'
  },
  cardBody: {
    padding: 28
  },
  cardFooter: {
    padding: '20px 28px',
    borderTop: '1px solid #f1f5f9',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12
  },

  // Form
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 20
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: '#374151',
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },
  input: {
    padding: '12px 14px',
    borderRadius: 10,
    border: '2px solid #e2e8f0',
    fontSize: 14,
    color: '#1e293b',
    outline: 'none',
    transition: 'all 0.2s',
    width: '100%',
    boxSizing: 'border-box'
  },

  // Buttons
  primaryBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
    color: 'white',
    border: 'none',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)'
  },
  secondaryBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '12px 24px',
    background: '#f1f5f9',
    color: '#475569',
    border: 'none',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer'
  },
  btnSpinner: {
    width: 16,
    height: 16,
    border: '2px solid rgba(255,255,255,0.3)',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite'
  },

  // Security Section
  securitySection: {
    padding: 20,
    border: '1px solid #e2e8f0',
    borderRadius: 12,
    marginBottom: 16
  },
  securityHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },
  securityIcon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: '#f3e8ff',
    color: '#7e22ce',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  securityTitle: {
    margin: 0,
    fontSize: 15,
    fontWeight: 600,
    color: '#1e293b'
  },
  securityDesc: {
    margin: '4px 0 0',
    fontSize: 13,
    color: '#64748b'
  },
  expandBtn: {
    marginLeft: 'auto',
    padding: '8px 16px',
    background: '#6366f1',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer'
  },
  passwordForm: {
    marginTop: 20,
    paddingTop: 20,
    borderTop: '1px solid #e2e8f0',
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  passwordField: {},
  passwordInputWrapper: {
    position: 'relative'
  },
  eyeBtn: {
    position: 'absolute',
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    color: '#94a3b8',
    cursor: 'pointer',
    padding: 4
  },

  // Info Grid
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 16,
    marginBottom: 32
  },
  infoItem: {
    padding: 16,
    background: '#f8fafc',
    borderRadius: 10
  },
  infoLabel: {
    fontSize: 12,
    color: '#64748b',
    fontWeight: 600,
    marginBottom: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },
  infoValue: {
    fontSize: 14,
    color: '#1e293b',
    fontWeight: 500
  },
  codeText: {
    background: '#e2e8f0',
    padding: '4px 8px',
    borderRadius: 4,
    fontSize: 13,
    fontFamily: 'monospace'
  },

  // Stats Section
  statsSection: {
    marginBottom: 32
  },
  statsSectionTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: '#1e293b',
    marginBottom: 16
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 16
  },
  statCard: {
    background: 'white',
    padding: 20,
    borderRadius: 12,
    border: '1px solid #e2e8f0',
    textAlign: 'center'
  },
  statCardIcon: {
    marginBottom: 8
  },
  statCardValue: {
    fontSize: 24,
    fontWeight: 700,
    color: '#1e293b'
  },
  statCardLabel: {
    fontSize: 12,
    color: '#64748b',
    marginTop: 4
  },

  // Danger Zone
  dangerZone: {
    padding: 20,
    background: '#fef2f2',
    borderRadius: 12,
    border: '1px solid #fecaca'
  },
  dangerTitle: {
    margin: '0 0 12px',
    fontSize: 15,
    fontWeight: 600,
    color: '#991b1b',
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  dangerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16
  },
  dangerText: {
    margin: 0,
    fontSize: 13,
    color: '#991b1b'
  },
  dangerBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '10px 16px',
    background: '#ef4444',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    cursor: 'not-allowed',
    opacity: 0.6
  }
};